import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'AZOCSII - 개인정보처리방침 | Privacy Policy';
  }, []);

  return (
    <div className="min-h-screen bg-bg-canvas">
      <div className="max-w-3xl mx-auto px-4 py-8 md:py-12">
        {/* 헤더 */}
        <div className="mb-8">
          <Link
            to="/"
            className="text-accent hover:text-accent-600 text-sm font-medium"
          >
            &larr; AZOCSII 홈으로
          </Link>
          <h1 className="text-2xl md:text-3xl font-bold text-primary mt-4">
            개인정보처리방침
          </h1>
          <p className="text-sm text-gray-500 mt-1">Privacy Policy</p>
          <p className="text-sm text-gray-400 mt-2">
            시행일: 2026년 4월 19일 | Effective: April 19, 2026
          </p>
        </div>

        <div className="space-y-8 text-gray-700 leading-relaxed">
          {/* 서비스 정보 */}
          <section>
            <p className="text-sm text-gray-500">
              <strong>서비스명:</strong> AZOCSII (아조씨)<br />
              <strong>운영:</strong> AZOCSII<br />
              <strong>연락처:</strong> azocsii@gmail.com
            </p>
          </section>

          {/* 1. 수집하는 개인정보 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              1. 수집하는 개인정보
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Personal Information We Collect
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-2 text-sm">
              <li>
                <strong>Google 소셜 로그인:</strong> 이름, 이메일 주소, 프로필 사진 (Google 제공 정보)
                <br />
                <span className="text-gray-400">
                  Google Sign-In: name, email, profile picture (provided by Google)
                </span>
              </li>
              <li>
                <strong>이메일 회원가입:</strong> 이메일 주소, 비밀번호 (암호화 저장)
                <br />
                <span className="text-gray-400">
                  Email registration: email, password (encrypted)
                </span>
              </li>
              <li>
                <strong>서비스 이용 시:</strong> 팀 정보, 역할 정보
                <br />
                <span className="text-gray-400">
                  During service use: team info, role info
                </span>
              </li>
            </ul>
          </section>

          {/* 2. 수집 목적 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              2. 개인정보 수집 목적
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Purpose of Collection
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>회원 식별 및 인증 / User identification and authentication</li>
              <li>서비스 제공 (노무 상담 플랫폼 기능) / Service delivery</li>
              <li>서비스 개선 및 기술 지원 / Service improvement and support</li>
            </ul>
          </section>

          {/* 3. 보관 및 파기 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              3. 개인정보 보관 및 파기
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Retention and Deletion
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>
                회원 탈퇴 시 지체 없이 파기
                <br />
                <span className="text-gray-400">
                  Deleted promptly upon account termination
                </span>
              </li>
              <li>
                법령에 따른 보관 의무가 있는 경우 해당 기간 보관
                <br />
                <span className="text-gray-400">
                  Retained as required by applicable laws
                </span>
              </li>
            </ul>
          </section>

          {/* 4. 제3자 제공 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              4. 개인정보 제3자 제공
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Third-Party Sharing
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>
                원칙적으로 제3자에게 제공하지 않음
                <br />
                <span className="text-gray-400">
                  Not shared with third parties as a rule
                </span>
              </li>
              <li>
                Firebase (Google): 인증 서비스 운영 목적
                <br />
                <span className="text-gray-400">
                  Firebase (Google): for authentication service operation
                </span>
              </li>
            </ul>
          </section>

          {/* 5. 이용자의 권리 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              5. 이용자의 권리
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                User Rights
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>
                개인정보 열람, 정정, 삭제 요청 가능
                <br />
                <span className="text-gray-400">
                  You may request access, correction, or deletion of your data
                </span>
              </li>
              <li>
                요청 방법: azocsii@gmail.com
                <br />
                <span className="text-gray-400">Contact: azocsii@gmail.com</span>
              </li>
            </ul>
          </section>

          {/* 6. 보안 조치 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              6. 보안 조치
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Security Measures
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>HTTPS(TLS) 암호화 통신 / HTTPS(TLS) encrypted communication</li>
              <li>비밀번호 해시 암호화 저장 / Password hash encryption</li>
              <li>접근 권한 최소화 / Minimum access privileges</li>
            </ul>
          </section>

          {/* 7. 쿠키 및 자동 수집 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              7. 쿠키 및 자동 수집
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Cookies and Automatic Collection
              </span>
            </h2>
            <p className="text-sm">
              Firebase Auth 세션 관리 목적 쿠키/토큰 사용
              <br />
              <span className="text-gray-400">
                Cookies/tokens used for Firebase Auth session management
              </span>
            </p>
          </section>

          {/* 8. 정책 변경 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              8. 정책 변경
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Policy Changes
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>
                변경 시 앱 내 공지 / Changes will be announced within the app
              </li>
              <li>
                시행일 기재 / Effective date will be specified
              </li>
            </ul>
          </section>

          {/* 9. 문의처 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              9. 문의처
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Contact
              </span>
            </h2>
            <p className="text-sm">
              <strong>개인정보 보호책임자:</strong> 김환희
              <br />
              <span className="text-gray-400">Data Protection Officer: Joelfelix Kim</span>
            </p>
            <p className="text-sm mt-2">
              이메일 / Email:{' '}
              <a
                href="mailto:azocsii@gmail.com"
                className="text-accent hover:underline"
              >
                azocsii@gmail.com
              </a>
            </p>
          </section>
        </div>

        {/* 상호 링크 */}
        <div className="mt-8 text-center">
          <Link
            to="/terms"
            className="text-sm text-accent hover:underline"
          >
            이용약관 보기
          </Link>
        </div>

        {/* 푸터 */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center text-xs text-gray-400">
          &copy; 2026 AZOCSII. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
